import styled from 'styled-components';
import colors from 'common/theme/saasModern/colors';
import { saasModernTheme } from 'common/theme/saasModern';

export const Card = styled.div`
  background-color: ${({ type }) =>
    type === 'Card 3 (Background Black)' ? '#1A1E26' : '#ffffff'};
  border-radius: 20px;
  padding: 24px;
  display: ${({ isFlex }) => (isFlex ? 'flex' : 'block')};
  gap: 16px;
  &:hover {
    box-shadow: ${saasModernTheme.gradiantShadow};
  }
`;

export const IconWrapper = styled.div`
  background-color: ${({ type }) =>
    type === 'Card 3 (Background Black)' ? '#2A303C' : '#f0f0f0'};
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: ${({ type }) =>
    type === 'Card 3 (Background Black)' ? '#ffffff' : colors.black};
  font-family: ${saasModernTheme.fontFamily};
`;

export const Description = styled.div`
  margin-top: 8px;
  color: ${({ type }) =>
    type === 'Card 3 (Background Black)' ? '#B0B7C3' : colors.gray};
  font-family: ${saasModernTheme.fontFamily};
`;

export const IndicatorBox = styled.div`
  width: 100%;
  height: auto;
  text-align: center;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    #e3f2ff,
    #fff1f1,
    #fff7e3
  );
  font-size: 16px;
  font-weight: 600;
  background-clip: padding-box;
  justify-content: center;
  display: flex;
  align-items: center;
  margin: 0 auto;
`;
export const IndicatorText = styled.h2`
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  vertical-align: bottom;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    90deg,
    #006fff,
    #ff6e72,
    #ffb656
  ); /* fond très doux */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`;
